'use client';

import { c as _c } from "react/compiler-runtime";
import type { InboxAutoFixSummariesResponse, InboxAutoFixSummary } from '@/app/(home)/inbox/api/pull-requests/auto-fix-summaries';
import { useQuery } from '@tanstack/react-query';
import { fetchInboxV2 } from '@/data/pull-requests/fetch-inbox-v2';
import { INBOX_V2_SIDE_LOAD_QUERY_OPTIONS } from '@/data/pull-requests/inbox-v2-side-load';
import { inboxV2AutoFixSummariesQueryKey } from '@/data/pull-requests/query-keys';
import { useSelectedRepositories } from '@/lib/hooks/use-selected-repositories';
async function fetchInboxV2AutoFixSummaries(installationId: number | null | undefined, signal: AbortSignal): Promise<Record<string, InboxAutoFixSummary>> {
  const data = await fetchInboxV2<Partial<InboxAutoFixSummariesResponse>>({
    path: '/inbox/api/pull-requests/auto-fix',
    installationId,
    query: {},
    signal,
    description: 'auto-fix summaries'
  });
  return data.autoFix ?? {};
}

/**
 * Auto-fix loop status for the open inbox rows, loaded beside the list like the
 * check summaries and refreshed by the inbox realtime listener on `AUTO_FIX`.
 */
export function useInboxV2AutoFixSummaries(options) {
  const $ = _c(12);
  const {
    selectedRepositoryIds: t0,
    normalizedInstallationId
  } = useSelectedRepositories();
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectedRepositoryIds = t1;
  let t2;
  if ($[2] !== normalizedInstallationId || $[3] !== selectedRepositoryIds) {
    t2 = inboxV2AutoFixSummariesQueryKey(normalizedInstallationId, selectedRepositoryIds);
    $[2] = normalizedInstallationId;
    $[3] = selectedRepositoryIds;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== normalizedInstallationId) {
    t3 = t4 => {
      const {
        signal
      } = t4;
      return fetchInboxV2AutoFixSummaries(normalizedInstallationId, signal);
    };
    $[5] = normalizedInstallationId;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = selectedRepositoryIds.length > 0;
  let t5;
  if ($[7] !== options.refetchOnMount || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = {
      ...INBOX_V2_SIDE_LOAD_QUERY_OPTIONS,
      queryKey: t2,
      queryFn: t3,
      enabled: t4,
      refetchOnMount: options.refetchOnMount
    };
    $[7] = options.refetchOnMount;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return useQuery(t5);
}